export const CA_REDIRECT = 'https://www.hollandamerica.com/en_US/deals_CAD/healthcare-firstresponder-appreciation-offer.html';
export const US_REDIRECT = 'https://www.hollandamerica.com/en_US/deals/healthcare-firstresponder-appreciation-offer.html';
